"use client"

import React from "react"
import styled from "styled-components"
import { P, Title } from "@motorata/base-ui.components.atoms.typography";
import { blockPadding, blockPaddingTop, blockStyles } from "@motorata/base-ui.components.atoms._atoms";
import Link from "@motorata/next.components.atoms.link";
import { NextImage } from "../common/Image";

const RentSection = () => {
  return (
    <Wrapper className="background">
      <Content>
        <TextWrapper>
          <Title type="secondary" label="Edukacja" elementType="label" color="white" labelColor="white">
            Sprawdź materiały, które dla was tworzymy!
          </Title>
          <P small color="white" marginBottom="L">
            Jeśli chcesz być na bierząco z samochodowymi nowościami, wyjątkowymi wydarzeniami, najnowszymi przepisami i informacjami, o których nigdzie się nie mówi, to zaobserwuj nas na Facebooku, Instagramie i Tiktoku. Znajdziesz tam również profesjonalne materiały stworzone przez naszych ekspertów.
          </P>
          <ButtonsWrapper>
            <Link icon="facebook" background="motorataDarker" href="https://www.facebook.com/motoratapl">
              Facebook
            </Link>
            <Link icon="instagram" background="motorataDarker" href="https://www.instagram.com/motorata.pl/">
              Instagram
            </Link>
            <Link icon="tiktok" background="motorataDarker" href="https://www.tiktok.com/@motoratapl">
              TikTok
            </Link>
          </ButtonsWrapper>
          {/*<Button margin="2rem 0 0">*/}
          {/*  Dowiedz się więcej*/}
          {/*</Button>*/}
        </TextWrapper>
        <ImageWrapper>
          <NextImage
            priority={true}
            fill
            src="/images/education_banner.png"
            alt="Grafika promująca materiały edukacyjne"
          />
        </ImageWrapper>
      </Content>
    </Wrapper>
  )
}

export default RentSection

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  grid-gap: ${({ theme }) => theme.space.XS};
  flex-wrap: wrap;
  `;

const TextWrapper = styled.div`
  ${blockPadding};
`

const ImageWrapper = styled.div`
  position: relative;
  
  img{
    ${blockPaddingTop};
    object-fit: contain;
    object-position: bottom;

    @media (max-width: 1100px) {
      padding-top: 0;
    }
  }
  
  @media (max-width: 850px) {
    height: 200px;
  }

  &:before {
    content: "";
    display: block;
    position: absolute;
    width: 50vw;
    right: calc((50% - 50vw) / 2);
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    clip-path: polygon(50% 0,100% 0,100% 100%,0% 100%);
    opacity: 0.2;

    @media (max-width: 850px) {
      height: 100%;
      width: 100vw;
      margin-left: calc((100vw - 100%) / -2);
      right: auto;
      left: 0;
      top: auto;
      bottom: 0;
    }
  }
`

const Content = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ theme }) => theme.space.M};

  @media (max-width: 1100px) {
    display: flex;
    flex-direction: column;
    grid-gap: 0;
  }
`

const Wrapper = styled.div`
  ${blockStyles};

  margin-bottom: 0;
  margin-top: 0;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:before {
    background: ${({ theme }) => theme.color.primary} !important;
  }
`
